import { render, staticRenderFns } from "./ZetaHubZoneForm.vue?vue&type=template&id=227755d9&"
import script from "./ZetaHubZoneForm.vue?vue&type=script&lang=ts&"
export * from "./ZetaHubZoneForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports